const LIMIT = 4000

// A keyed notepad the model reads by parts: the prompt only carries the index, a note costs tokens when read.
// Writing an empty text deletes the key. Nothing here is ever read by a condition
export function noteTools(itemScope: string): PlaybookTool[] {
  const scopeOf = (scope: string) => scope === "playbook" ? "playbook" : itemScope
  const parameters = (extra: any = {}) => ({
    type: "object",
    properties: { scope: { type: "string", enum: ["item", "playbook"], description: "item notes are only seen here, playbook notes everywhere" }, key: { type: "string" }, ...extra },
    required: ["scope", "key", ...Object.keys(extra)],
  })

  return [
    {
      name: "note_read",
      description: "Reads one of your notes by key.",
      parameters: parameters(),
      run: async ({ scope, key }, run) => run.state.notes?.[scopeOf(scope)]?.[key] ?? "No such note.",
    },
    {
      name: "note_write",
      description: "Writes a note for later turns, replacing the key. Condense instead of appending. An empty text deletes it.",
      parameters: parameters({ text: { type: "string" } }),
      run: async ({ scope, key, text }, run) => {
        const notes = run.state.notes ||= {}
        const page = { ...notes[scopeOf(scope)] }
        if (text) page[key] = text
        else delete page[key]
        const size = Object.values(page).reduce((n, t) => n + t.length, 0)
        if (size > LIMIT) return `Not saved: the ${scope} notes would use ${size} characters, the limit is ${LIMIT}. Condense or delete another note first.`
        notes[scopeOf(scope)] = page
        return "Saved."
      },
    },
  ]
}

// What goes beside the context so the model knows what it has without reading it
export function noteIndex(notes: { [scope: string]: { [key: string]: string } } | undefined, itemScope: string): string {
  const list = (scope: string) => Object.entries(notes?.[scope] || {}).map(([key, text]) => `${key} (${text.length} chars)`).join(", ") || "none"
  return `Your notes. Item: ${list(itemScope)}. Playbook: ${list("playbook")}.`
}
